import React from 'react'

const FirstIcon = () => {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.977 9.44a.64.64 0 0 1 .33.56v12a.64.64 0 0 1-1.28 0V11.154l-2.643 1.65a.64.64 0 1 1-.678-1.086l3.622-2.261a.64.64 0 0 1 .65-.017Z"
      fill="url(#a)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.998 2.734h13.309v13.309a13.344 13.344 0 0 1-13.305 13.305l-.002-.64-.002.64A13.344 13.344 0 0 1 2.693 16.043l.64-.002-.64-.002A13.344 13.344 0 0 1 15.998 2.734ZM3.973 16.041A12.064 12.064 0 0 0 16 28.068 12.064 12.064 0 0 0 28.027 16.04V4.013H16.001A12.064 12.064 0 0 0 3.973 16.041Z"
      fill="url(#b)"
    />
    <defs>
      <radialGradient
        id="a"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(-110.177 18.383 6.59) scale(20.7699 45.7501)"
      >
        <stop stopColor="#E60000" />
        <stop offset={1} stopColor="#9C2AA0" />
      </radialGradient>
      <radialGradient
        id="b"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(-38.89594 -39.06875 132.90371 -132.31583 35.987 36.32)"
      >
        <stop stopColor="#E60000" />
        <stop offset={1} stopColor="#9C2AA0" />
      </radialGradient>
    </defs>
  </svg>
  )
}

export default FirstIcon